import axios from "../axios";

export type OAuthClient = {
  id: number;
  name: string;
  redirect: string;
  created_at?: string;
  revoked?: boolean;
  personal_access_client?: boolean;
  password_client?: boolean;
  // Passport may return extra fields depending on version/config.
  [key: string]: unknown;
};

export type CreateOAuthClientRequest = {
  name: string;
  redirect: string;
};

export type CreateOAuthClientResponse = OAuthClient & {
  secret: string;
};

export async function listOAuthClients(signal?: AbortSignal) {
  // Laravel Passport's built-in endpoint returns an array (no { data: ... } envelope).
  return (await axios.get<OAuthClient[]>("/api/v1/oauth/clients", { signal }))
    .data;
}

export async function createOAuthClient(
  payload: CreateOAuthClientRequest,
  signal?: AbortSignal
) {
  // Returns the created client, including `secret` (only returned once).
  return (
    await axios.post<CreateOAuthClientResponse>(
      "/api/v1/oauth/clients",
      payload,
      {
        signal,
      }
    )
  ).data;
}

export async function deleteOAuthClient(id: number, signal?: AbortSignal) {
  await axios.delete(`/api/v1/oauth/clients/${id}`, { signal });
}
